import React from "react";

export default function PokerHandStrength({ hand, compact = false }) {
  const label = hand?.label;
  const description = hand?.description;
  const text = [label || "Waiting for cards", description].filter(Boolean).join(" - ");

  if (compact) {
    return (
      <div className="flex min-w-0 max-w-full items-center gap-2 overflow-hidden">
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-amber-200/85 shadow-[0_0_8px_rgba(251,191,36,0.58)]" />
        <span className="shrink-0 text-[8px] font-black uppercase tracking-[0.18em] text-amber-100/60">
          Your hand
        </span>
        <span className="min-w-0 truncate text-[10px] font-black uppercase tracking-[0.08em] text-amber-50 sm:text-[11px]">
          {text}
        </span>
      </div>
    );
  }

  return (
    <div className="relative min-h-[46px] w-full min-w-0 overflow-hidden rounded-lg border border-amber-200/20 bg-[linear-gradient(135deg,rgba(251,191,36,0.14),rgba(12,10,8,0.92)_42%,rgba(2,6,23,0.82))] px-3 py-2 shadow-[0_10px_24px_rgba(0,0,0,0.28),inset_0_1px_0_rgba(255,255,255,0.06)]">
      <div className="pointer-events-none absolute inset-y-1 left-1 w-1 rounded-full bg-amber-200/70 shadow-[0_0_14px_rgba(251,191,36,0.38)]" />
      <div className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-amber-100/22 to-transparent" />
      <div className="flex min-w-0 items-center justify-between gap-3 pl-2.5">
        <div className="min-w-0">
          <div className="flex items-center gap-1.5 text-[9px] font-black uppercase tracking-[0.2em] text-amber-100/68">
            <span className="h-1.5 w-1.5 rounded-full bg-amber-200/80 shadow-[0_0_8px_rgba(251,191,36,0.55)]" />
            Your hand
          </div>
          <div className="mt-0.5 truncate text-[15px] font-black leading-tight text-amber-50">
            {label || "Waiting for cards"}
          </div>
        </div>
        {description ? (
          <div className="max-w-[48%] shrink-0 truncate rounded-md border border-white/[0.08] bg-black/28 px-2.5 py-1 text-right font-mono text-[11px] font-bold uppercase tracking-[0.08em] text-emerald-50/88 shadow-[inset_0_1px_0_rgba(255,255,255,0.04)]">
            {description}
          </div>
        ) : null}
      </div>
    </div>
  );
}
